import {
  useEffect,
  useMemo,
  useState
} from "react";

import AccountShell
  from "./accountShell";

import TableOrder
  from "../../section/tableOrder";

import {
  getOrderByUser
} from "../../api/order";

const getUser = () => {
  try {
    return JSON.parse(
      localStorage.getItem("user")
    );
  } catch (e) {
    return null;
  }
};

export default function AccountOrders() {
  const user =
    useMemo(() => getUser(), []);

  const [order, setOrder] =
    useState(null);

  const [
    pagination,
    setPagination
  ] = useState({
    page: 1,
    pageSize: 5
  });

  useEffect(() => {
    if (!user?.user_id) {
      return;
    }

    const query =
      `page=${pagination.page}` +
      `&pageSize=${pagination.pageSize}`;

    getOrderByUser(
      user.user_id,
      query,
      setOrder
    );
  }, [
    user,
    pagination.page,
    pagination.pageSize
  ]);

  return (
    <AccountShell
      title="Đơn hàng của tôi"
      description="Theo dõi lịch sử và trạng thái đơn hàng"
    >
      <TableOrder
        order={order}
        pagination={pagination}
        setPagination={setPagination}
      />
    </AccountShell>
  );
}
